/*
 * @Author: leventlei
 * @Date: 2024-04-04 11:19:01
 * @LastEditTime: 2024-04-04 13:59:15
 * @LastEditors: leventlei
 * @Description:项目选择器
 * @FilePath: /IOT4CMS/src/layouts/baseLayout/header/components/ProjectSelector/index.tsx
 */
import React, { FC, useEffect, useState } from 'react'

import { Select } from 'antd'
import { Dispatch, GlobalModelState, connect, useLocation } from 'umi'
import './index.less'
import { t } from '@wangeditor/editor'

export interface ProjectSelectorProps {
	dispatch: Dispatch
	global: GlobalModelState
	handleSelectorChange: any
	options: any
	placeholder: any
	selectValueProps: any
}

const ProjectSelector: FC<ProjectSelectorProps> = ({
	dispatch,
	global,
	handleSelectorChange,
	options,
	placeholder,
	selectValueProps,
}) => {
	// const location = useLocation()

	// useEffect(() => {
	// 	let currentProjectId =
	// 		Number(sessionStorage.getItem('_projectId')) !== 0
	// 			? Number(sessionStorage.getItem('_projectId'))
	// 			: null
	// 	dispatch({
	// 		type: 'global/save',
	// 		payload: {
	// 			projectId: currentProjectId, //默认无项目id
	// 			instanceId: null, //默认无实例id
	// 			areaId: null, //默认无地区id
	// 			cityId: null, //默认无城市id
	// 		},
	// 	})
	// 	// if (selectValueProps !== null || selectValueProps !== '') {
	// 	// 	setSelectValue(null)
	// 	// }
	// }, [location.pathname])
	// useEffect(()=>{
	// 	setSelectValue(selectValueProps)
	// },[selectValueProps])

	return (
		<div className="ProjectSelector-container">
			<Select
				className="selector-style"
				value={selectValueProps}
				placeholder={placeholder}
				onChange={handleSelectorChange}
				options={options}
				// allowClear={true}
			/>
		</div>
	)
}

export default connect(({ global }: { global: GlobalModelState }) => ({
	global,
}))(ProjectSelector)
